import { render } from "./EmployeeClaims.vue?vue&type=template&id=789d7422"
import script from "./EmployeeClaims.vue?vue&type=script&lang=js"
export * from "./EmployeeClaims.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__